import { create } from 'zustand';

export const useProfileStore = create((set, get) => ({
  // État initial
  profile: null,

  // Actions
  setProfile: (newProfile) => set({ profile: newProfile }),

  clearProfile: () => set({ profile: null }),

  getProfile: () => get().profile,

  isProfileLoaded: () => get().profile !== null,
}));
